import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=f722ab62&scoped=true"
import script from "./Mapping.vue?vue&type=script&lang=js"
export * from "./Mapping.vue?vue&type=script&lang=js"
import style0 from "./Mapping.vue?vue&type=style&index=0&id=f722ab62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f722ab62",
  null
  
)

export default component.exports